const rankings = [
  { rank: 1, title: '凤隐天下', type: '古装剧', heat: '🔥 1.28亿', change: 'up', desc: '权谋虐恋，演技派全员在线' },
  { rank: 2, title: '镜像追踪', type: '悬疑剧', heat: '🔥 9,600万', change: 'up', desc: '高能反转，口碑炸裂' },
  { rank: 3, title: '暗夜边境 S5', type: '科幻剧', heat: '🔥 8,200万', change: 'same', desc: '末日史诗，全球同步追' },
  { rank: 4, title: '无声暗战', type: '谍战剧', heat: '🔥 7,500万', change: 'up', desc: '民国谍战，老戏骨飙戏' },
  { rank: 5, title: '山海秘境', type: '动画电影', heat: '🔥 6,800万', change: 'down', desc: '票房破30亿，国漫之光' },
  { rank: 6, title: '面包和汤和猫咪', type: '治愈日剧', heat: '🔥 5,400万', change: 'up', desc: '一集入魂，温暖治愈' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          热播榜单
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-[480px] mx-auto">
          根据观看热度和讨论量实时更新的热门影视排行
        </p>

        <div className="max-w-[800px] mx-auto grid grid-cols-1 gap-3">
          {rankings.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 p-4 bg-background-50 border border-background-200/70 rounded-xl hover:border-primary-300 transition-all duration-200 cursor-pointer"
            >
              <div className={`w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-lg font-heading text-sm md:text-base font-bold flex-shrink-0 ${
                item.rank <= 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 whitespace-nowrap">
                    {item.title}
                  </h3>
                  <span className="text-[10px] md:text-xs text-foreground-400 bg-background-100 px-2 py-0.5 rounded-md whitespace-nowrap">
                    {item.type}
                  </span>
                  <span className={`text-[10px] ${item.change === 'up' ? 'text-primary-600' : item.change === 'down' ? 'text-foreground-400' : 'text-foreground-400'}`}>
                    {item.change === 'up' && <i className="ri-arrow-up-line"></i>}
                    {item.change === 'down' && <i className="ri-arrow-down-line"></i>}
                    {item.change === 'same' && <i className="ri-subtract-line"></i>}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 mt-0.5 line-clamp-1">{item.desc}</p>
              </div>
              <div className="text-xs md:text-sm font-semibold text-accent-600 whitespace-nowrap">
                {item.heat}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}